module.exports = __webpack_public_path__ + "img/wz-8-3-3.80364713.jpg";